<template>
    <div class="add-escrow-officers">
        <b-form-row>
            <b-col>
                <b-form-group>
                    <label
                        class="text-gray-dark font-weight-bold"
                        for="escrow-officer-name"
                    >
                        Escrow Officer Name
                    </label>
                    <b-form-input
                        id="escrow-officer-name"
                        v-model="escrowOfficerName"
                    ></b-form-input>
                </b-form-group>
            </b-col>

            <b-col>
                <b-form-group>
                    <label
                        class="text-gray-dark font-weight-bold"
                        for="escrow-officer-email"
                    >
                        Escrow Officer Email Address
                    </label>
                    <b-form-input
                        id="escrow-officer-email"
                        v-model="escrowOfficerEmail"
                    ></b-form-input>
                    <b-form-invalid-feedback
                        :state="isEmailValid"
                        class="mt-2"
                    >
                        {{ errors.email }}
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>

            <b-col>
                <b-form-group>
                    <label
                        class="text-gray-dark font-weight-bold"
                        for="title-company-name"
                    >
                        Title Company Name
                    </label>
                    <b-form-input
                        id="title-company-name"
                        v-model="titleCompany"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-form-row>
        <b-form-row>
            <b-form-checkbox :class="{'hide-checkbox': hideAddNewContactsCheckbox}" v-model="saveToPreferred">Save information to preferred escrow officers.</b-form-checkbox>
        </b-form-row>
    </div>
</template>

<script>
import './EscrowOfficers.scss';
import { isValidEmail } from "@helpers/email";
import ContactAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/ContactAppResource";
import { ESCROW_OFFICER } from "@sellers-shield-home-protection/ss-core-js/src/AppResources/LuContactTypeAppResource";
import { mapState} from 'pinia';
import {useAuthStore} from '@store';
import { TRANSACTION_COORDINATOR } from "@sellers-shield-home-protection/ss-core-js/src/AppResources/LuAccountTypeAppResource"

export default {
    name: 'AddEscrowOfficers',
    data() {
        return {
            escrowOfficerName: '',
            escrowOfficerEmail: '',
            titleCompany: '',
            errors: {
                email: ''
            },
            contactAppResource: new ContactAppResource({}),
            saveToPreferred: false,
        };
    },
    computed: {
        ...mapState(useAuthStore, {
            me: 'me',
        }),
        isEmailValid() {
            return isValidEmail(this.escrowOfficerEmail);
        },
        hideAddNewContactsCheckbox(){
            return this.me.accountTypeId === TRANSACTION_COORDINATOR;
        }
    },
    methods: {
        async addEscrowOfficer() {
            //add to contatcs list if user chooses that
            this.contactAppResource.setAttribute('fullName', this.escrowOfficerName);
            this.contactAppResource.setAttribute('email', this.escrowOfficerEmail);
            this.contactAppResource.setAttribute('userUuid', this.me.uuid);
            this.contactAppResource.setAttribute('contactTypeId', ESCROW_OFFICER);
            this.contactAppResource.setAttribute('companyName', this.titleCompany);

            if (this.saveToPreferred){
                await this.contactAppResource.save();
            }
            this.$emit('add-new-escrow-officer', {fullName: this.escrowOfficerName, email: this.escrowOfficerEmail, companyName: this.titleCompany})

        },
        async submitEscrowInfo() {
            if (this.isEmailValid) {
                await this.addEscrowOfficer();  
                return this.contactAppResource;
            }
        },
        validateEmail() {
            let email = this.escrowOfficerEmail;
            if (email.length === 0) {
                this.errors.email = '';
                return;
            }
            if (isValidEmail(email)) {
                this.errors.email = '';
            } else {
                this.errors.email = 'Invalid Email Address';
            }
        }
    },
}
</script>